import type { FaireProductEntity } from "../../entity_types/product";

export const p_1rmjmf09yi: FaireProductEntity = {
  token: "p_1rmjmf09yi",
  type: "product",
  name: "Pencil Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/8d482ced5645e6c232ace820d4cd9ee1b51ce56bae3f8561aadbbd9364f95262.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e9b58f4774c811878e7d9b38e977991f168169b361f87906b67bb564dc011334.jpeg",
    "https://cdn.faire.com/fastly/a04766e5817414b7b8d4b4d585db7ad1973a67ab65159344d1ff6e14ba850596.png",
    "https://cdn.faire.com/fastly/dc01332324e9353f45511551468434d3a4c7b022f8b0bc90b7c0d284a03ea5bf.png",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:46.443Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
